import React from 'react'

const Indd = ({ viewBox }) => (
  <svg viewBox={viewBox}>
    <path
      fill="#E9E9E0"
      d="M10.359,0C8.366,0,6.736,1.63,6.736,3.624v50.72c0,1.996,1.63,3.623,3.623,3.623h36.229
	c1.993,0,3.623-1.627,3.623-3.623V14.492L35.72,0H10.359z"
    />
    <path
      fill="#D9D7CA"
      d="M39.341,14.492h10.87L35.72,0v10.87C35.72,12.861,37.351,14.492,39.341,14.492z"
    />
    <path
      fill="#9F66A3"
      d="M50.123,56.301c0,0.996-0.815,1.809-1.813,1.809H8.459c-0.996,0-1.812-0.812-1.812-1.809V38.186
	c0-0.996,0.816-1.811,1.812-1.811H48.31c0.998,0,1.813,0.814,1.813,1.811V56.301z"
    />
    <g>
      <path
        fill="#FFFFFF"
        d="M9.52,43.525c0-1.189,1.911-1.234,1.911,0v8.27c0,1.201-1.911,1.232-1.911,0V43.525z"
      />
      <path
        fill="#FFFFFF"
        d="M14,43.67c0-0.523,0.116-1.029,0.868-1.029c0.522,0,0.638,0.129,1.029,0.506l4.792,5.996v-5.617
		c0-0.479,0.419-1.002,0.914-1.002c0.521,0,1.027,0.523,1.027,1.002v8.152c0,0.641-0.391,0.885-0.768,1
		c-0.505,0-0.754-0.115-1.173-0.506l-4.792-6.084v5.59c0,0.641-0.391,1-0.913,1c-0.522,0-0.984-0.359-0.984-1V43.67z"
      />
      <path
        fill="#FFFFFF"
        d="M26.145,52.678c-0.479,0-1-0.262-1-0.896v-8.227c0-0.523,0.521-0.9,1-0.9h3.317
		c6.619,0,6.474,10.023,0.13,10.023H26.145z M27.058,44.424v6.488h2.404c3.911,0,4.083-6.488,0-6.488H27.058z"
      />
      <path
        fill="#FFFFFF"
        d="M37.393,52.678c-0.478,0-1-0.262-1-0.896v-8.227c0-0.523,0.522-0.9,1-0.9h3.319
		c6.617,0,6.471,10.023,0.128,10.023H37.393z M38.306,44.424v6.488h2.406c3.906,0,4.082-6.488,0-6.488H38.306z"
      />
    </g>
  </svg>
)

export default Indd



// WEBPACK FOOTER //
// ./src/components/Svg/indd.js